import { API } from 'configs';
import { usePaging } from 'utils/AxiosHooks';

const useGetTransactions = () => usePaging(API.ADMIN.TRANSACTION.LIST, false);

export { useGetTransactions };
